import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button'
import { Table, Space } from 'antd';
import 'antd/dist/antd.css';
import '../../Home.css';

const data = [
    {
        key: '1',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '2',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '3',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '4',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '5',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '6',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '7',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '8',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '9',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '10',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '11',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '12',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '13',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '14',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '15',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '16',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '17',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '18',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '19',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '20',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '21',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
    {
        key: '22',
        title: 'title x',
        address: 0x56587657,
        amount: 'xxx USD',
        term: 'x Month',
    },
];

function Leading(props) {
    const [sf, setSf] = useState({
        filteredInfo: null,
        sortedInfo: null,
    })
    const [addNew, setAddNew] = useState(false);

    const handleChange = (pagination, filters, sorter) => {
        console.log('Various parameters', pagination, filters, sorter);

        setSf({
            filteredInfo: null,
            sortedInfo: null,
        });
    };

    let { sortedInfo, filteredInfo } = sf;
    sortedInfo = sortedInfo || {};
    filteredInfo = filteredInfo || {};
    const columns = [
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            filteredValue: filteredInfo.title || null,
            onFilter: (value, record) => record.title.includes(value),
            sorter: (a, b) => a.title.length - b.title.length,
            sortOrder: sortedInfo.columnKey === 'title' && sortedInfo.order,
            ellipsis: true,
        },
        {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
            sorter: (a, b) => a.address - b.address,
            sortOrder: sortedInfo.columnKey === 'address' && sortedInfo.order,
            ellipsis: true,
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            filteredValue: filteredInfo.amount || null,
            onFilter: (value, record) => record.amount.includes(value),
            sorter: (a, b) => a.amount.length - b.amount.length,
            sortOrder: sortedInfo.columnKey === 'amount' && sortedInfo.order,
            ellipsis: true,
        },
        {
            title: 'Term',
            dataIndex: 'term',
            key: 'term',
            filteredValue: filteredInfo.term || null,
            onFilter: (value, record) => record.term.includes(value),
            sorter: (a, b) => a.term.length - b.term.length,
            sortOrder: sortedInfo.columnKey === 'term' && sortedInfo.order,
            ellipsis: true,
        },
        {
            title: 'Action',
            dataIndex: 'address',
            render(text, record) {
                return {
                    children: <div className='action-btn' >
                        <button>Action</button>
                    </div>
                };
            },
            sortOrder: sortedInfo.columnKey === 'address' && sortedInfo.order,
            ellipsis: true,
        },
    ];


    return (
        <>
            {addNew === false && (
                <div>
                    <Space className='mt-5' style={{ marginBottom: 16 }}>
                    </Space>
                    <div className='l-l-heading' >
                        <div>Leading</div>
                        <div><button onClick={() => setAddNew(true)}>Add New</button></div>
                    </div>
                    <div className='l-l-para' >Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime exercitationem
                    corporis omnis itaque sunt dicta iste nam mollitia amet eos earum accusantium sint
                    explicabo similique quasi porro maiores, ullam commodi.
                    </div>
                    <Table columns={columns} dataSource={data} onChange={handleChange} />
                </div>
            )}
            {addNew === true && (
                <div>
                    <Container>
                        <Row>
                            <Col lg={8} className='offset-lg-2'>
                                <div className='second-row'>
                                    <div className='second-row-item'>
                                        <Form.Group>
                                            <Form.Row>
                                                <Form.Label column lg={4}>
                                                    NFT Address
                                                </Form.Label>
                                                <Col>
                                                    <Form.Control as="select">
                                                        <option>Monalisa</option>
                                                        <option>Tom cruise</option>
                                                        <option>Arnold</option>
                                                        <option>Heavy Machine</option>
                                                        <option>Iron Man</option>
                                                    </Form.Control>
                                                </Col>
                                            </Form.Row>
                                            <br />
                                            <Form.Row>
                                                <Form.Label column lg={4}>
                                                    Daily rent amount
                                                </Form.Label>
                                                <Col>
                                                    <Form.Control type="text" placeholder="Meta URL" />
                                                </Col>
                                            </Form.Row>
                                            <br />
                                            <Form.Row>
                                                <Form.Label column lg={4}>
                                                    Max lease duration
                                                </Form.Label>
                                                <Col>
                                                    <Form.Control type="text" placeholder="Description" />
                                                </Col>
                                            </Form.Row>
                                            <br />
                                            <br />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={8} md={8} className='offset-lg-2 offset-md-2'>
                                <div className='third-row'>
                                    <Button variant="secondary" size="lg" onClick={() => setAddNew(false)}>Cancel</Button>
                                    <Button variant="success" size="lg" onClick={() => setAddNew(false)}>Success</Button>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            )}
        </>
    );
}

export default Leading;